class SubscriptionModal extends HTMLElement {
  constructor() {
    super();

    if (window.location.pathname === '/challenge') return;

    this.cookieKey = 'subscription-modal';
    this.states = {
      bodyActive: 'modal-open',
      visible: 'is-visible',
      hiding: 'is-hiding',
      imageVisible: 'has-image',
      checkoutMode: 'is-checkout-mode'
    };

    this.modal = this.querySelector('.modal-wrapper');

    // Luister naar succesvolle form submissions
    this.initFormSubmitListener();

    // Als er succes- of foutmeldingen in de form staan na een pagina Herlaad / POST
    if (this.querySelector('.form__note')) {
      const isCheckout = window._checkoutIntended || sessionStorage.getItem('checkout_mode_active') === 'true';
      
      // FIX BUG 1: Als het formulier succesvol is verzonden, markeer als aangemeld
      if (this.querySelector('.subscription-form__note--success')) {
        localStorage.setItem('senzara_subscribed', 'true');
      }

      this.show(isCheckout ? 'checkout' : 'homepage');
    }

    // Toggle-knoppen (sluitknop)
    this.querySelectorAll('[data-modal-toggle]').forEach((btn) =>
      btn.addEventListener('click', this.handleToggle.bind(this))
    );

    // Automatische timer voor homepage popup
    if (!this.getCookie(this.cookieKey) || this.dataset.testMode === 'true') {
      this.start();
    }
  }

  // FIX BUG 1: Event listener voor succesvolle form submits
  initFormSubmitListener() {
    const forms = this.querySelectorAll('form');
    forms.forEach((form) => {
      form.addEventListener('submit', () => {
        // Markeer in localStorage bij aanmelding
        localStorage.setItem('senzara_subscribed', 'true');
      });
    });
  }

  connectedCallback() {
    if (window.Shopify && Shopify.designMode) {
      this.onLoadHandler = this.handleLoad.bind(this);
      this.onSelectHandler = this.handleSelect.bind(this);
      this.onDeselectHandler = this.handleDeselect.bind(this);
      document.addEventListener('shopify:section:load', this.onLoadHandler);
      document.addEventListener('shopify:section:select', this.onSelectHandler);
      document.addEventListener('shopify:section:deselect', this.onDeselectHandler);
    }
  }

  disconnectedCallback() {
    if (window.Shopify && Shopify.designMode) {
      document.removeEventListener('shopify:section:load', this.onLoadHandler);
      document.removeEventListener('shopify:section:select', this.onSelectHandler);
      document.removeEventListener('shopify:section:deselect', this.onDeselectHandler);
      document.body.classList.remove(this.states.bodyActive);
    }
  }

  handleLoad(event) { this.filterEvent(event, () => this.show('homepage')); }
  handleSelect(event) { this.filterEvent(event, () => this.show('homepage')); }
  handleDeselect(event) { this.filterEvent(event, this.hide.bind(this)); }

  start() {
    if (window.Shopify && Shopify.designMode) return;
    
    const delay = parseInt(this.dataset.delay, 10) || 0;
    setTimeout(() => {
      // Blokkeer de homepage popup als de gebruiker al op afrekenen heeft gedrukt
      if (window._checkoutIntended) return;

      if (this.dataset.disabled !== 'true') {
        this.show('homepage');
      }
    }, delay * 1000);
  }

  handleToggle(event) {
    if (event) event.preventDefault();
    if (this.modal.classList.contains(this.states.visible)) {
      this.hide();
    } else {
      this.show();
    }
  }

  show(type) {
    const isCheckout = type === 'checkout' || window._checkoutIntended;
    const homepageContent = this.querySelector('#homepage-popup-content');
    const checkoutContent = this.querySelector('#checkout-popup-content');

    if (isCheckout) {
      this.classList.add(this.states.checkoutMode);
      sessionStorage.setItem('checkout_mode_active', 'true');
      
      // Dwing de juiste content te tonen
      if (homepageContent) homepageContent.style.setProperty('display', 'none', 'important');
      if (checkoutContent) checkoutContent.style.setProperty('display', 'block', 'important');
    } else {
      this.classList.remove(this.states.checkoutMode);
      sessionStorage.removeItem('checkout_mode_active');

      // Dwing de homepage content te tonen
      if (homepageContent) homepageContent.style.setProperty('display', 'block', 'important');
      if (checkoutContent) checkoutContent.style.setProperty('display', 'none', 'important');
    }

    document.body.classList.add(this.states.bodyActive);
    this.modal.classList.add(this.states.visible);
    this.modal.style.zIndex = '99999';

    setTimeout(() => this.modal.classList.add(this.states.imageVisible), 500);
  }

  hide() {
    const wasCheckoutMode = this.classList.contains(this.states.checkoutMode) || window._checkoutIntended;

    window._checkoutPopupDismissed = true;

    this.modal.classList.add(this.states.hiding);

    setTimeout(() => {
      this.modal.classList.remove(this.states.visible);
      this.modal.classList.remove(this.states.hiding);
      this.modal.classList.remove(this.states.imageVisible);
      this.classList.remove(this.states.checkoutMode);
      document.body.classList.remove(this.states.bodyActive);

      if (wasCheckoutMode) {
        window._checkoutIntended = false;
        window.location.href = '/checkout';
      }
    }, 400);

    if (this.dataset.testMode === 'true') {
      this.clearCookie(this.cookieKey);
      return;
    }

    const expiryDays = parseInt(this.dataset.expiry, 10) || 7;
    this.storeCookie(this.cookieKey, expiryDays);
  }

  getCookie(key) {
    const cookie = document.cookie.match(`(^|;)\\s*${key}\\s*=\\s*([^;]+)`);
    return cookie ? cookie[2] : null;
  }

  storeCookie(key, days) {
    document.cookie = `${key}=true; max-age=${days * 24 * 60 * 60}; path=/`;
  }

  clearCookie(key) {
    document.cookie = `${key}=; max-age=0; path=/`;
  }

  filterEvent(event, callback) {
    if (event.type.includes('shopify:section')) {
      if (this.hasAttribute('data-section-id') &&
          this.getAttribute('data-section-id') === event.detail.sectionId) {
        callback(event);
      }
    }
  }
}

// Global click event handler - Capture Phase (draait VOORDAT theme scripts de klik opvangen)
document.addEventListener('click', function(event) {
  const checkoutBtn = event.target.closest('[data-checkout-trigger]');
  if (!checkoutBtn) return;
  if (event.target.closest('subscription-modal')) return;

  // FIX BUG 1: Als de bezoeker al is ingeschreven, stuur direct door naar checkout
  if (localStorage.getItem('senzara_subscribed') === 'true') {
    window.location.href = '/checkout';
    return;
  }

  // FIX BUG 2: Als de checkout popup eerder al is weggedrukt, stuur direct door naar checkout
  if (window._checkoutPopupDismissed) {
    window._checkoutPopupDismissed = false;
    window.location.href = '/checkout';
    return;
  }

  event.preventDefault();
  event.stopPropagation(); // Voorkom dat het theme de afrekenactie direct uitvoert

  // 1. Markeer globale intentie
  window._checkoutIntended = true;

  // 2. Zoek de modal
  const modal = document.querySelector('subscription-modal');

  // 3. Sluit actieve cart drawers indien aanwezig
  const drawer = document.querySelector('cart-drawer-component, cart-drawer');
  if (drawer && typeof drawer.close === 'function') {
    drawer.close();
  }

  // 4. Open expliciet de checkout popup
  if (modal) {
    modal.show('checkout');
  }
}, true); // <--- True is cruciaal: vangt het event als allereerste op

// Define Custom Element
if (!customElements.get('subscription-modal')) {
  customElements.define('subscription-modal', SubscriptionModal);
}
